module.exports = __webpack_public_path__ + "static/media/Lisci_vrch.72d8b6d2.md";